import ItemWidgetController from "./ItemWidgetController";

export default ItemWidgetController;
